define([
  'angular',
  'mod',
  'common/Utils'
], function(angular, mod) {

var m = require('am');

m.factory('upState', ['$state', '$browser', '$stateParams', function($state, $browser, $stateParams) {
  return function(current) {
    current = current || $state.current;
    var result = {};
    if (!current || current.name === '') {
      return {};
    }
    if ('up' in current) {
      var up = current.up;
      if (_.isFunction(up)) {
        up = up($stateParams);
      }
      if (_.isPlainObject(up)) {
        result = up;
      }
      var state = _.find([result.state, up], function(v) {
        return _.isString(v) && $state.get(v);
      });
      if (state) {
        result.state = state;
      } else {
        result.url = up;
      }
    }
    if (current.parent) {
      result = {state: current.parent, title: current.parent.title};
    } else {
      result = {url: '/', title: 'Home'};
    }
    if (_.isString(result.state)) {
      result.state = $state.get(result.state);
    }
    _.defaults(result, {
      params: {},
      options: {},
      title: result.state && result.state.title
    });
    if (_.isFunction(result.title)) {
      var params = _.defaults(result.params, $stateParams);
      result.title = result.title(params);
    }
    return result;
  };
}]);

m.directive('upState', ['upState', '$state', function(upState, $state) {
  // Usage:
  // <a up-state></a>
  return {
    scope: true,
    template: '<a ng-href="{{ url }}">{{ title }}</a>',
    replace: true,
    controller: ['$scope', function($scope) {
      $scope.$watch(function() {
        return $state.current;
      }, function(state) {
        if (state && state.name !== '') {
          var s = upState(state);
          $scope.title = s.title || 'Up a Level';
          if (s.state) {
            $scope.url = $state.href(s.state, s.params, s.options);
          } else {
            $scope.url = s.url || '/';
          }
        }
      });
    }]
  };
}]);

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/SiteNav/SiteNav.js
 **/